

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CssBaseline, Container, Box } from '@mui/material';
import { SettingsProvider } from './context/SettingsContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import LoudnessPage from './pages/LoudnessPage';
import MCLPage from './pages/MCLPage';
import FDTPage from './pages/FDTPage';
import AboutPage from './pages/AboutPage';


function App() {
  return (
    <SettingsProvider>
      <Router>
        <CssBaseline />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh'
          }}
        >
          <Navbar />
          <Container sx={{ flex: 1, mt: 2, mb: 8 }}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/loudness" element={<LoudnessPage />} />
              <Route path="/mcl" element={<MCLPage />} />
              <Route path="/fdt" element={<FDTPage />} />
              <Route path="/about" element={<AboutPage />} />
            </Routes>
          </Container>
          <Footer />
        </Box>
      </Router>
    </SettingsProvider>
  );
}

export default App;
